const standardEvents = () => {
  document.addEventListener('click', (e) => {
    if (!e.target.classList.contains('standard-event')) {
      return;
    }
    window.dataLayer.push({
      event: 'customEvent',
      GAeventCategory: e.target.dataset.eventCategory,
      GAeventAction: e.target.dataset.eventAction,
      GAeventLabel: e.target.dataset.eventLabel,
      GAeventValue: e.target.dataset.eventValue,
    });
  });
};

standardEvents();
